export default "__VITE_ASSET__BFP2vN6t__"